import { Button } from '@heroui/react'
import { motion } from 'framer-motion'
import { AlertCircle, ArrowRight, RefreshCw } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const Error = () => {
  const navigate = useNavigate()

  const handleGoToDashboard = () => {
    navigate('/dashboard/management/users')
  }

  return (
    <div className="bg-gradient-to-br h-screen relative bg-white dark:bg-black flex items-center justify-center p-4">
      <div className="absolute inset-0 overflow-hidden h-full">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-300/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-300/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary-300/10 rounded-full blur-3xl" />
      </div>

      <div className="relative">
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          className="relative z-10 p-8 max-w-md"
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
        >
          <div className="text-center">
            {/* Error Icon */}
            <motion.div
              animate={{ scale: 1 }}
              className="w-16 h-16 mx-auto mb-6 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center"
              initial={{ scale: 0 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
            >
              <AlertCircle className="w-8 h-8 text-red-500" />
            </motion.div>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
              Oops! Something went wrong
            </h2>

            <p className="text-gray-600 dark:text-gray-300 mb-6">
              We couldn't retrieve your payment details. Please try again or contact support if the
              problem persists.
            </p>

            {/* Action Buttons */}
            <div className="space-y-3">
              <Button
                className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold"
                color="primary"
                size="lg"
                startContent={<RefreshCw className="w-4 h-4" />}
                variant="shadow"
                onPress={() => window.location.reload()}
              >
                Try Again
              </Button>

              <Button
                className="w-full text-gray-600 dark:text-gray-300"
                size="lg"
                startContent={<ArrowRight className="w-4 h-4 rotate-180" />}
                variant="light"
                onPress={handleGoToDashboard}
              >
                Go to Dashboard
              </Button>
            </div>

            {/* <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800/50">
              <p className="text-xs text-red-600 dark:text-[#DD524C]">
                Error: {(error as any)?.message || 'Failed to load session data'}
              </p>
            </div> */}
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Error
